"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CloudOff_exports = {};
__export(CloudOff_exports, {
  default: () => CloudOff_default
});
module.exports = __toCommonJS(CloudOff_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.61287 4.80028C5.41349 4.63545 5.11769 4.64635 4.93107 4.83298C4.73287 5.03118 4.73287 5.35252 4.93107 5.55072L7.23414 7.85377C6.68375 8.64033 6.36115 9.58873 6.36115 10.6158C6.36115 10.6554 6.36164 10.695 6.3626 10.7345C4.43896 10.8346 2.91 12.426 2.91 14.3746C2.91 16.3877 4.54198 18.0197 6.55512 18.0197L17.4002 18.0197L18.9315 19.5511C19.1297 19.7493 19.4511 19.7493 19.6493 19.5511C19.8357 19.3646 19.8468 19.0693 19.6825 18.8699L5.61287 4.80028ZM6.55512 16.8197L16.2002 16.8197L8.10156 8.72118C7.75733 9.28016 7.56115 9.92881 7.56115 10.6158C7.56115 10.7022 7.56422 10.788 7.57025 10.8728C7.81001 10.9423 8.03975 11.0356 8.25658 11.1502C8.54954 11.3051 8.66149 11.6681 8.50663 11.9611C8.35177 12.254 7.98874 12.366 7.69578 12.2111C7.35587 12.0315 6.96829 11.9295 6.55512 11.9295C5.20472 11.9295 4.11 13.0242 4.11 14.3746C4.11 15.725 5.20472 16.8197 6.55512 16.8197Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.4836 17.3561C19.7179 17.1851 19.9318 16.9876 20.1215 16.7716C20.7611 16.0436 21.1627 15.0679 21.1627 14.0701C21.1627 12.0569 19.5307 10.4249 17.5176 10.4249C17.2352 10.4249 16.96 10.4572 16.6955 10.5182C16.6412 7.79822 14.3231 5.65405 11.5288 5.65405C10.4609 5.65405 9.46257 5.96722 8.63355 6.50601L9.50581 7.37827C10.0955 7.04593 10.7859 6.85405 11.5288 6.85405C13.7465 6.85405 15.4965 8.56402 15.4965 10.6158C15.4965 10.8244 15.4786 11.0287 15.4444 11.2274C15.403 11.4674 15.5105 11.6988 15.7001 11.8268C15.8818 11.9866 16.1503 12.0264 16.3769 11.9066C16.7168 11.7269 17.1044 11.6249 17.5176 11.6249C18.868 11.6249 19.9627 12.7197 19.9627 14.0701C19.9627 14.754 19.6826 15.4531 19.22 15.9795C19.0399 16.1846 18.8375 16.3577 18.62 16.4925L19.4836 17.3561Z",
      fill: "currentColor"
    }
  )
);
const SvgCloudOff = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var CloudOff_default = SvgCloudOff;
